import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  ${setCssVar('accentColor', brand.hta.green)};
  ${setCssVar('accentColorAlt', brand.hta.greenDark)};
  ${setCssVar('bgColor', brand.white)};
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('fgColorAlt', brand.hta.greenAlt)};

  .theme-hh & {
    ${setCssVar('accentColor', brand.hortHouse.green)};
    ${setCssVar('accentColorAlt', brand.hortHouse.green)};
    ${setCssVar('fgColor', brand.white)};
    ${setCssVar('fgColorAlt', brand.white)};
  }

  .theme-apl & {
    ${setCssVar('accentColor', brand.apl.green)};
    ${setCssVar('accentColorAlt', brand.black)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.black)};
  }

  color: ${cssVar('fgColor')};
`;
const Title = styled.h2 `
  ${HeadingStyles.H3Styles}
  color: ${cssVar('fgColorAlt')};
  margin: 0 0 24px;

  @media ${until(Device.Tablet)} {
    font-size: 30px;
    line-height: 40px;
    margin: 0 0 15px;
  }
`;
const Subtitle = styled.h3 `
  color: ${cssVar('fgColor')};
  ${fonts.sourceSansPro.bold};
  font-size: 22px;
  line-height: 28px;
  margin: 0 0 15px;

  @media ${from(Device.Tablet)} {
    font-size: 22px;
    line-height: 34px;
    margin: 0;
  }
`;
const Content = styled.div `
  ${fonts.sourceSansPro.regular};
  font-size: 18px;
  line-height: 28px;
  margin: 0 0 48px;
  max-width: 804px;

  @media ${from(Device.Tablet)} {
    font-size: 24px;
    line-height: 34px;
    margin: 0 0 48px;
  }
`;
const ItemList = styled.div `
  display: grid;
  gap: 58px 10px;
  grid-template-columns: repeat(12, 1fr);

  @media ${from(Device.Tablet)} {
    gap: 112px 30px;
  }
`;
const Item = styled.div `
  grid-column: span 12;
  margin: 0 auto;
  max-width: 349px;

  @media ${from(Device.Tablet)} {
    grid-column: span 6;
    margin: 0;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: span 4;
  }

  @media ${from(Device.Desktop)} {
    grid-column: span 3;
  }
`;
export default {
    Container,
    Content,
    Item,
    ItemList,
    Subtitle,
    Title,
};
